import { Flex, Heading, Stack, Highlight, Box, Button } from "@chakra-ui/react";
import { memo, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import NotFoundSVG from "../../utils/graphics/NotFoundSVG";

const NotFoundPage = () => {
  const navigate = useNavigate();

  const onClickGoToDashboard = useCallback(() => {
    navigate("/dashboard");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex
      direction="column"
      gap={8}
      height="30vw"
      width="100%"
      justifyContent="center"
      alignItems="center"
    >
      <NotFoundSVG />
      <Stack direction="column" gap={4} alignItems="center">
        <Heading>{"Não foi possível encontrar a página."}</Heading>
        <Box>
          <Highlight query="Painel de Controlo" styles={{ fontWeight: "700" }}>
            {"Regresse ao Painel de Controlo."}
          </Highlight>
        </Box>
      </Stack>
      <Button variant="primary" onClick={onClickGoToDashboard}>
        {"Ir para o Painel de Controlo"}
      </Button>
    </Flex>
  );
};

export default memo(NotFoundPage);
